import { render, staticRenderFns } from "./SelectedBox.vue?vue&type=template&id=75dc06d2&scoped=true&"
import script from "./SelectedBox.vue?vue&type=script&lang=js&"
export * from "./SelectedBox.vue?vue&type=script&lang=js&"
import style0 from "./SelectedBox.vue?vue&type=style&index=0&id=75dc06d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dc06d2",
  null
  
)

export default component.exports